var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38266 1.75525C7.596 1.19259 8.40333 1.19259 8.61733 1.75525L9.99733 5.57792C10.094 5.83125 10.34 5.99992 10.6147 5.99992H14.006C14.6327 5.99992 14.906 6.77992 14.4133 7.16192L12 9.33325C11.8919 9.41636 11.8129 9.53157 11.7743 9.66236C11.7358 9.79315 11.7396 9.93279 11.7853 10.0613L12.6667 13.7966C12.8813 14.3966 12.1867 14.9119 11.6613 14.5426L8.38333 12.4626C8.27107 12.3837 8.13721 12.3414 8 12.3414C7.86279 12.3414 7.72892 12.3837 7.61666 12.4626L4.33866 14.5426C3.814 14.9119 3.11866 14.3959 3.33333 13.7966L4.21466 10.0613C4.26038 9.93279 4.26424 9.79315 4.22567 9.66236C4.1871 9.53157 4.1081 9.41636 4 9.33325L1.58666 7.16192C1.09333 6.77992 1.368 5.99992 1.99333 5.99992H5.38466C5.51819 6.00036 5.64871 5.96025 5.75894 5.8849C5.86918 5.80955 5.95393 5.7025 6.002 5.57792L7.382 1.75525H7.38266Z",
    stroke: "#F3EDF3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.806e786e07fe4c2e85f5639d6ed59b04.svg";
export { ForwardRef as ReactComponent };